var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2832 8.90576C2.2832 5.59676 4.9742 2.90576 8.2832 2.90576C11.5922 2.90576 14.2832 5.59676 14.2832 8.90576C14.2832 12.2148 11.5922 14.9058 8.2832 14.9058C4.9742 14.9058 2.2832 12.2148 2.2832 8.90576ZM17.9902 17.1988L14.5952 13.8028C15.6482 12.4488 16.2832 10.7518 16.2832 8.90576C16.2832 4.49476 12.6942 0.905762 8.2832 0.905762C3.8722 0.905762 0.283203 4.49476 0.283203 8.90576C0.283203 13.3168 3.8722 16.9058 8.2832 16.9058C10.1292 16.9058 11.8262 16.2708 13.1802 15.2178L16.5762 18.6128C16.7712 18.8078 17.0272 18.9058 17.2832 18.9058C17.5392 18.9058 17.7952 18.8078 17.9902 18.6128C18.3812 18.2218 18.3812 17.5898 17.9902 17.1988Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.86e62862aa709660cc9740fdb42f4b64.svg";
export { ForwardRef as ReactComponent };